import EnrollmentOutcomes from './enrollmentoutcomes'

export default EnrollmentOutcomes
